import React, {useEffect} from "react";
import {useObserver} from "mobx-react-lite";
import {useHistory, useLocation} from "react-router-dom";

import {useStore} from "../../hooks/useStore";
import {getStartRoute} from "../../utils/getStartRoute";
import {LoginFormRedesign} from "./LoginFormRedesign";

export const LoginPage = props => {
    const stores = useStore();
    const history = useHistory();
    const {search} = useLocation();

    useEffect(() => {
        if (new URLSearchParams(search).get("clearUserStorage") === "true") {
            stores.meStore.resetMeStoreData();
        }
        if (stores.meStore.isLoggedIn) {
            history.push(
                getStartRoute({
                    role: stores?.meStore?.role,
                    isPoolCustomer: stores?.meStore?.isPoolCustomer,
                    isUatCustomer: stores?.meStore?.isUatCustomer
                })
            );
        }
    }, []);

    return useObserver(() => <LoginFormRedesign />);
};
